export default __webpack_public_path__ + "static/media/card1.2bbd9383.png";